import { Component, inject, input } from '@angular/core';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import {
  COLLATERAL_APPROVED_ROUTE,
  COLLATERAL_REJECTED_ROUTE,
  COLLATERAL_ROUTE,
  COLLATERAL_WAITING_ROUTE,
} from '../../../../data-access/constants/app-routes';

import { NgxButtonComponent } from '@digipay/ngx-button';
import { ECollateralRequestStatus } from '../../models/collateral-request-status.enum';
import { CollateralService } from '../../services/collateral.service';
import { IProcessData } from '../../models/process-data.interface';
import { ECollateralPage } from '../../models/collatetral-page.enum';
import { NgClass } from '@angular/common';

@Component({
  selector: 'wealth-applet-collateral-touch-point',
  standalone: true,
  imports: [NgxButtonComponent, NgClass],
  templateUrl: './collateral-touch-point.component.html',
  styleUrl: './collateral-touch-point.component.scss',
})
export class CollateralTouchPointComponent {
  title = input<string>();
  description = input<string>();
  symbol = input<string>();
  state = input<ECollateralRequestStatus>();

  resutlState = ECollateralRequestStatus;

  navigationService = inject(WealthNavigationService);

  constructor(private collateralService: CollateralService) {}

  navigateToCollateral() {
    const data: IProcessData = {
      instrumentSymbol: this.symbol(),
      action: 'start_journey',
    };
    this.collateralService.process(data).subscribe((res) => {
      if (res?.success) {
        switch (res.result.data.pageName) {
          case ECollateralPage.page_collateral_landing:
            this.navigationService.navigate([COLLATERAL_ROUTE, this.symbol()], {
              state: {
                symbol: this.symbol(),
                coordinatorAction: res.result.data.coordinatorAction,
              },
            });
            break;

          case ECollateralPage.page_collateral_pending:
            this.navigationService.navigate([COLLATERAL_WAITING_ROUTE], {
              state: {
                symbol: this.symbol(),
              },
            });
            break;

          case ECollateralPage.page_collateral_rejected:
            this.navigationService.navigate([COLLATERAL_REJECTED_ROUTE], {
              state: {
                symbol: this.symbol(),
                instrumentTitle: res.result.data.instrumentTitle,
              },
            });
            break;

          case ECollateralPage.page_collateral_approved:
            this.navigationService.navigate([COLLATERAL_APPROVED_ROUTE], {
              state: {
                symbol: this.symbol(),
                instrumentTitle: res.result.data.instrumentTitle,
                collateralAmount: res.result.data.collateralAmount,
              },
            });
            break;

          default:
            break;
        }
      }
    });

    // "collateral_amount": "470,000,000",
    //         "instrumentTitle": "ارزش آفرین گلرنگ",
    //         "pageName": "page_collateral_approved"

    // switch (this.state()) {
    //   case ECollateralRequestStatus.Approved:
    //     this.navigationService.navigate([COLLATERAL_APPROVED_ROUTE], {
    //       state: {
    //         symbol: this.symbol(),
    //       },
    //     });
    //     break;
    //   case ECollateralRequestStatus.Rejected:
    //     this.navigationService.navigate([COLLATERAL_REJECTED_ROUTE], {
    //       state: {
    //         symbol: this.symbol(),
    //       },
    //     });
    //     break;
    //   case ECollateralRequestStatus.Pending:
    //     this.navigationService.navigate([COLLATERAL_WAITING_ROUTE], {
    //       state: {
    //         symbol: this.symbol(),
    //       },
    //     });
    //     break;
    //   case ECollateralRequestStatus.Init:

    //     this.navigationService.navigate([COLLATERAL_ROUTE, this.symbol()], {
    //       state: {
    //         symbol: this.symbol(),
    //       },
    //     });
    //     break;
    // }
  }
}
